import { t } from 'i18next'
import { Chart } from 'primereact/chart'
import React, { useState } from 'react'
import { SalutationCt } from '../../../../model/enums/enums'
import { useAppSelector } from '../../../../redux/hooks'

export const ApprenticeGenderStatistic = () => {
  const apprentices = useAppSelector((state) => state.apprentices)
  const totalFemale = apprentices.filter(
    (a) => a.salutation === SalutationCt.Ms
  )?.length
  const totalMale = apprentices.filter(
    (a) => a.salutation === SalutationCt.Mr
  )?.length
  const totalDiverse = apprentices.filter(
    (a) => a.salutation === SalutationCt.Diverse
  )?.length
  const totalNotDefined = apprentices.filter(
    (a) => a.salutation === SalutationCt.NoSpecification
  )?.length

  const [apprenticesChartData] = useState({
    labels: [
      t<string>('core.statistic.women'),
      t<string>('core.statistic.men'),
      t<string>('core.statistic.diverse'),
      t<string>('core.statistic.not_specified'),
    ],
    datasets: [
      {
        data: [totalFemale, totalMale, totalDiverse, totalNotDefined],
        backgroundColor: [
          '#E0979E',
          'rgb(0, 127, 192)',
          '#8d7a70',
          'rgb(135, 136, 138)',
        ],
        hoverBackgroundColor: [
          '#ffa7b0',
          'rgb(0,163,248)',
          '#d5b7a7',
          'rgb(204,204,204)',
        ],
      },
    ],
  })

  return (
    <div className={'col card-hover'}>
      <h5 className={'statistic-text pb-2'}>
        {t<string>('core.statistic.count_apprentices_gender')} (
        {apprentices.length})
      </h5>
      <div className={'grid justify-content-center align-items-center'}>
        <Chart
          width={'240px'}
          height={'240px'}
          type={'doughnut'}
          data={apprenticesChartData}
        />
      </div>
    </div>
  )
}